import { useEffect, useMemo, useState } from "react";
import { matchPath } from "react-router-dom";
import { useGlobalState } from "../../../contexts/GlobalContext";
import { Routes } from "../../../utils/constants";

export const useLayoutMenu = () => {
  const [isShowMenu, setIsShowMenu] = useState(false);
  const { globalState } = useGlobalState();
  const showMenuPaths = [
    Routes.NOTIFICATION,
    Routes.USER,
    Routes.EMAILSETTING,
    Routes.EMAILCHANGECOMPLETE,
    Routes.PASSWORDSETTING,
    // Routes.WITHDRAWAL,
    // Routes.WITHDRAWALCONFIRM,
    Routes.LOGINERROR,
    Routes.USERSETTING,
    Routes.MASSMEDIAN,
    Routes.CLIPPING,
  ];

  const hideMenuPaths = [
    Routes.Events,
    Routes.SURVEY_ANSWER,
    Routes.SURVEY_ANSWER_CONFIRM,
    Routes.SURVEY_ANSWER_FINISH,
    Routes.WITHDRAWALFINISH,
    Routes.SURVEY,
    Routes.SURVEYERR,
    Routes.USERGUEST,
    Routes.OPTOUTNOTIFICATION,
    Routes.EMAIL_CHANGE,
    Routes.SESSION_VIDEO,
    Routes.CONFIRMSUCCESS,
    Routes.CONFIRMERROR,
    Routes.CREATEUSERERROR,
  ];

  const onMenuClick = () => {
    setIsShowMenu(!isShowMenu);
  };

  const shouldRenderMenu = useMemo(() => {
    return globalState.isAuthenticated &&
      !hideMenuPaths.some((path) =>
        matchPath(path, location.pathname)
      );
  }, [globalState.isAuthenticated, location.pathname]);

  useEffect(() => {
    // メニュー表示制御
    if (window.innerWidth > 776) {
      const isShowMenuPath = showMenuPaths.some(
        (path) =>
          matchPath(path, location.pathname)
      );
      setIsShowMenu(isShowMenuPath);
    }
  }, [location.pathname]);

  return {
    isShowMenu,
    setIsShowMenu,
    onMenuClick,
    shouldRenderMenu,
  }
}
